'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paperColor = function paperColor() {
  return 'paper-color-' + new Date().getTime();
};

function OpenBook(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 64 : _ref$size,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? null : _ref$icon;

  var instancePaperColorId = paperColor();
  return _react2.default.createElement(
    'div',
    { style: { width: size, height: size + 9 }, className: 'jsx-1749448321' + ' ' + 'holder'
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-1749448321' + ' ' + 'icon'
      },
      icon
    ),
    _react2.default.createElement(
      'svg',
      { width: size, height: size + 9, viewBox: '0 0 44 53', className: 'jsx-1749448321'
      },
      _react2.default.createElement(
        'defs',
        {
          className: 'jsx-1749448321'
        },
        _react2.default.createElement(
          'linearGradient',
          {
            x1: '50%',
            y1: '0%',
            x2: '50%',
            y2: '100%',
            id: instancePaperColorId,
            className: 'jsx-1749448321'
          },
          _react2.default.createElement('stop', { stopColor: '#F4F4F4', offset: '97.0723055%', className: 'jsx-1749448321'
          }),
          _react2.default.createElement('stop', { stopColor: '#F2F2F2', offset: '0%', className: 'jsx-1749448321'
          })
        )
      ),
      _react2.default.createElement(
        'g',
        { transform: 'translate(-6.000000, -2.000000)', className: 'jsx-1749448321'
        },
        _react2.default.createElement('path', {
          d: 'M49.38 46.91C49.38 49.722 47 52 44.064 52h-24.66c-2.782 0-5.037-2.278-5.037-5.088V18.48c0-2.81 2.255-5.088 5.037-5.088h24.66c2.937 0 5.318 2.277 5.318 5.088v28.43z',
          fill: '#49497F',
          className: 'jsx-1749448321'
        }),
        _react2.default.createElement('path', {
          d: 'M17.96 10.25h23a6 6 0 0 1 6 6v27a6 6 0 0 1-6 6h-23v-39z',
          fill: 'url(#' + instancePaperColorId + ')',
          className: 'jsx-1749448321'
        }),
        _react2.default.createElement('path', {
          d: 'M39.849 21.851h-15.7c-.356 0-.643-.363-.643-.811 0-.448.287-.812.643-.812h15.7c.356 0 .643.364.643.812 0 .448-.287.811-.643.811m0 4.938h-15.7c-.356 0-.643-.363-.643-.811 0-.448.287-.812.643-.812h15.7c.356 0 .643.364.643.812 0 .448-.287.811-.643.811m0 4.938h-15.7c-.356 0-.643-.363-.643-.811 0-.448.287-.812.643-.812h15.7c.356 0 .643.364.643.812 0 .448-.287.811-.643.811m0 4.49h-15.7c-.356 0-.643-.364-.643-.812 0-.448.287-.811.643-.811h15.7c.356 0 .643.363.643.811 0 .448-.287.812-.643.812m0 4.938h-15.7c-.356 0-.643-.364-.643-.812 0-.448.287-.811.643-.811h15.7c.356 0 .643.363.643.811 0 .448-.287.812-.643.812',
          fill: '#878E91',
          className: 'jsx-1749448321'
        }),
        _react2.default.createElement('path', {
          d: 'M6.461 37.762c0 3.354 1.698 5.84 3.112 7.003 3.976 3.267 5.202 4.936 6.93 6.336-.46-2.8-.854-16.137-1.181-40.009 0-2.04-1.58-3.886-4.739-5.54-1.874-2.334-3.98-3.12-3.98-.062-.095 16.1-.142 26.858-.142 32.272z',
          fill: '#49497F',
          className: 'jsx-1749448321'
        }),
        _react2.default.createElement('path', {
          d: 'M17.957 10.25l-6.523-6.21c-1.201-1.142-2.175-.46-2.175 1.522v31.424c0 1.984.974 4.518 2.175 5.661l6.523 6.21V10.25z',
          fill: '#BCBCBC',
          className: 'jsx-1749448321'
        }),
        _react2.default.createElement('path', {
          d: 'M17.957 10.25L13.1 3.145c-.894-1.308-1.619-.76-1.619 1.223v31.424c0 1.983.725 4.651 1.62 5.96l4.855 7.104V10.25z',
          fill: '#D8D8D8',
          className: 'jsx-1749448321'
        }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(22.668715, 8.005632)', fillRule: 'nonzero', className: 'jsx-1749448321'
          },
          _react2.default.createElement('polygon', {
            fill: '#F06361',
            points: '10.955269 2.24455918 10.955269 46.237919 7.2248176 44.5800588 3.49932032 46.237919 3.45955863 2.24455918',
            className: 'jsx-1749448321'
          }),
          _react2.default.createElement('path', {
            d: 'M1.698 0h7.52l1.737 2.245H0S-.015 0 1.698 0z',
            fill: '#C64757',
            className: 'jsx-1749448321'
          }),
          _react2.default.createElement('path', {
            d: 'M1.73 0h7.493s1.732 0 1.732 2.245H3.487S3.5 0 1.73 0z',
            fill: '#F06361',
            className: 'jsx-1749448321'
          })
        )
      )
    ),
    _react2.default.createElement(
      _style2.default,
      {
        id: '1749448321'
      },
      ['.holder.jsx-1749448321{position:relative;display:inline-block;}', '.icon.jsx-1749448321{position:absolute;bottom:-10%;right:-5%;z-index:2;}']
    )
  );
}

OpenBook.propTypes = {
  size: _propTypes2.default.number,
  icon: _propTypes2.default.node
};

exports.default = OpenBook;